<template lang="html">
  <sui-modal v-model="open" :closable="false">
    <sui-modal-header>Hilfe</sui-modal-header>
    <sui-modal-content scrolling>
      <sui-modal-description>
        <fieldset>
          <legend>&nbsp;Hilfe&nbsp;</legend>
          <h4 class="sui-header">FAQ – Häufig gestellte Fragen</h4>
          <sui-list ordered>
            <sui-list-item>
              <a href="#a">Zugangskarten</a>
              <sui-list-list>
                <sui-list-item>
                  <a href="#aa">Der Unterschied zwischen Zeitablauf und Zeitguthaben?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#ab">Ausloggen Guthabenkarte</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#ac">Ausloggen Zeitablauf</a>
                </sui-list-item>
              </sui-list-list>
            </sui-list-item>
            <sui-list-item>
              <a href="#b">Zugangsprobleme</a>
              <sui-list-list>
                <sui-list-item>
                  <a href="#ba">Ich lande immer wieder auf der Startseite</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#bb">Session-Limit wurde erreicht</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#bc">Der Button, um die AGBs zu bestätigen, wird bei mir nicht angezeigt</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#bd">Ich habe eingeschränkte oder keine Konnektivität</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#be">Ich werde trotz einer Zeitablauf-Karte ausgeloggt</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#bf">Meine IP Adresse beginnt mit 169….</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#bg">Ich bekomme die Fehlermeldung: „Die Website kann nicht angezeigt werden“</a>
                </sui-list-item>
              </sui-list-list>
            </sui-list-item>
            <sui-list-item>
              <a href="#c"> Verschiedenes</a>
              <sui-list-list>
                <sui-list-item>
                  <a href="#ca">Auf meinem Tablet/Smartphone bekommen meine Apps keinen Internetzugriff.</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#cb">Ich kann mittels WhatsApp weder Nachrichten senden noch empfangen.</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#cc">Kann ich meine Mails am Hotspot abrufen?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#cd">Ist VPN möglich?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#ce">Ich kann meinen ausländischen SMTP-Server nicht erreichen</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#cf"> Kann ich meine Spielekonsole / Smartphone / Tablet nutzen?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#cg">Gibt es Portsperren?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#ch">Wie kann ich Zugangsdaten online erwerben?</a>
                </sui-list-item>
                <sui-list-item>
                  <a href="#ci">Wie bekomme ich eine Quittung/Rechnung?</a>
                </sui-list-item>
              </sui-list-list>
            </sui-list-item>
          </sui-list>

          <a name="a"></a>
          <h3 class="sui-header">Zugangskarten</h3>
          <a name="aa"></a>
          <h4 class="sui-header">Der Unterschied zwischen Zeitablauf und Zeitguthaben?</h4>
          <p><b>Zeitablauf-Voucher</b> beginnen mit dem Start der Nutzung (und nicht mit dem Kauf). Mit Beginn der Nutzung läuft die Zeit, unabhängig davon, ob man die Karte tatsächlich nutzt. Zum Beispiel endet die Zeit bei einer Tageskarte (24h Zeitablauf) 24 Stunden nach Beginn der Nutzung. In dieser Zeit kann man sich beliebig oft einloggen und unbegrenzt Traffic verbrauchen, entsprechend einer 24h-Flatrate</p>
          <p><b>Zeitguthaben-Voucher</b> können beliebig aufgeteilt werden. Die Abrechnung erfolgt sekundengenau. Guthabenkarten sind im Verhältnis teurer.</p>
          <a name="ab"></a>
          <h4 class="sui-header">Ausloggen Guthabenkarte</h4>
          <p>Damit das Guthaben im Falle einer Verbindungsunterbrechung nicht verfällt, registriert das System die Inaktivität und loggt den Nutzer nach 15 Min. automatisch aus. Die 15 Min. bis zur letzten Aktivität werden der Karte wieder gutgeschrieben. Weniger als 15 Min. Restguthaben auf der Karte verfallen. Durch rechtzeitiges Ausloggen kann dies vermieden werden. Zurück auf die Login-/Logoutseite führt: <a href="login.lan1.de">login.lan1.de</a></p>
          <p><b>ACHTUNG: Häufig laufen Programme im Hintergrund und unterbinden die Inaktivität (E-Mail-Abfrage, Antivirus Update etc.).</b></p>
          <a name="ac"></a>
          <h4 class="sui-header">Ausloggen Zeitablauf</h4>
          <p>Mit einer Zeitablaufkarte (Tag, Woche, Monat …) können Sie sich ausloggen, müssen es aber nicht, da es sich um Flatrate-Tarife handelt. Sie können beliebig lange online bleiben. Die Karte läuft nicht schneller ab und es entstehen keine zusätzlichen Kosten. Es gibt auch keine sonstigen Beschränkungen (Traffic, Ports, VPN, Mail).</p>

          <a name="b"></a>
          <h3 class="sui-header">Zugangsprobleme</h3>
          <a name="ba"></a>
          <h4 class="sui-header">Ich lande immer wieder auf der Startseite</h4>
          <p>Bitte prüfen Sie den Usernamen und das Passwort. Es werden nur Kleinbuchstaben verwendet! Ist Username und Passwort korrekt – dann kontaktieren Sie bitte unserer Hotline: <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a>.</p>
          <a name="bb"></a>
          <h4 class="sui-header">Session-Limit wurde erreicht</h4>
          <p>Die Zugangsdaten sind nur an drei Endgeräten zur gleichen Zeit nutzbar. Sobald die Zugangsdaten an einem vierten Gerät verwendet werden, bekommen Sie die Fehlermeldung „Session Limit wurde erreicht“.</p>
          <a name="bc"></a>
          <h4 class="sui-header">Der Button, um die AGBs zu bestätigen, wird bei mir nicht angezeigt</h4>
          <p>Bitte kontaktieren Sie die Hotline: <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a></p>
          <a name="bd"></a>
          <h4 class="sui-header">Ich habe eingeschränkte oder keine Konnektivität</h4>
          <p>Dies deutet auf einen Fehler im Netzwerk hin. Möglicherweise ist auch die Reichweite des WLAN-Adapters nicht ausreichend. Falls weitere Lan1-Netzwerke in Reichweite sind, versuchen Sie sich bitte mit einem dieser Netzwerke zu verbinden. Gegebenenfalls hilft es, Ihren WLAN-Adapter neu zu starten, dies geschieht auch zwangsläufig bei einem Neustart des Endgeräts. Wird Ihnen weiterhin eine eingeschränkte Konnektivität angezeigt, kontaktieren Sie bitte unsere Hotline: <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a></p>
          <a name="be"></a>
          <h4 class="sui-header">Ich werde trotz einer Zeitablauf-Karte ausgeloggt</h4>
          <p>Das System wird nachts neu gestartet. Dabei werden zwangsläufig alle Nutzer einmal ausgeloggt. Darüber hinaus gibt es einen Inaktivitäts-Timeout. Nach 4 Stunden Inaktivität werden auch Ablaufkarten automatisch ausgeloggt.</p>
          <a name="bf"></a>
          <h4 class="sui-header">Meine IP Adresse beginnt mit 169….</h4>
          <p>Bei der Zuweisung der IP-Adresse ist es zu Problemen gekommen, bitte starten Sie Ihr Endgerät neu und versuchen erneut die WLAN-Verbindung herzustellen. Sollten Sie weiterhin eine 169er-IP erhalten, wenden Sie sich bitte an die Hotline: <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a></p>
          <a name="bg"></a>
          <h4 class="sui-header">Ich bekomme die Fehlermeldung: „Die Website kann nicht angezeigt werden“</h4>
          <p>Bitte überprüfen Sie, ob Sie eine aktive WLAN-Verbindung haben. Evtl. ist bei Ihnen auch ein Proxy aktiviert. Die Proxyeinstellungen finden Sie in den Einstellungen Ihres Browsers.</p>

          <a name="c"></a>
          <h3 class="sui-header">Verschiedenes</h3>
          <a name="#ca"></a>
          <h4 class="sui-header">Auf meinem Tablet/Smartphone bekommen meine Apps keinen Internetzugriff.</h4>
          <p>Sie müssen sich zuerst über Ihren Browser an dem jeweiligen Hotspot einloggen, anschließend erhalten alle Ihre Apps den gewünschten Internetzugriff.</p>

          <a name="#cb"></a>
          <h4 class="sui-header">Ich kann mittels WhatsApp weder Nachrichten senden noch empfangen.</h4>
          <p>Sie sind an dem Hotspot noch nicht eingeloggt. Öffnen Sie bitte Ihren Browser und geben Sie Ihre Zugangsdaten ein oder bestätigen Sie die AGB’s.</p>

          <a name="#cc"></a>
          <h4 class="sui-header">Kann ich meine Mails am Hotspot abrufen?</h4>
          <p>Vor dem Abrufen der Mails müssen Sie angemeldet sein. Sobald Sie Usernamen und Passwort auf unserer Startseite eingegeben haben, können Sie wie gewohnt Ihre Mails abrufen.</p>

          <a name="#cd"></a>
          <h4 class="sui-header">Ist VPN möglich?</h4>
          <p>Vor dem Aufbau einer VPN Verbindung müssen Sie angemeldet sein. Sobald Sie Usernamen und Passwort auf unserer Startseite eingegeben haben, können Sie wie gewohnt Ihre VPN Verbindung aufbauen.</p>

          <a name="#ce"></a>
          <h4 class="sui-header">Ich kann meinen ausländischen SMTP-Server nicht erreichen</h4>
          <p>Einige ausländische SMTP–Server können von Deutschland aus nicht erreicht werden. Ebenso können einige deutsche SMTP–Server nicht vom Ausland her erreicht werden. LAN1 bietet keinen frei nutzbaren SMTP–Server. Hier finden Sie eine Liste kostenloser SMTP–Server: <a href="https://www.patshaping.de/hilfen_ta/pop3_smtp.htm" target="_blank">https://www.patshaping.de/hilfen_ta/pop3_smtp.htm</a></p>

          <a name="#cf"></a>
          <h4 class="sui-header"> Kann ich meine Spielekonsole / Smartphone / Tablet nutzen?</h4>
          <p>So lange Ihre Spielekonsole oder sonstiges Endgerät in der Lage ist, eine Internetseite aufzurufen, können Sie sich problemlos einloggen. Anschließend stehen Ihnen alle Onlinefunktionen Ihrer Konsole bzw. des Endgerätes zur Verfügung. Verfügt Ihr Endgerät über keinen Browser, wenden Sie sich bitte an unsere Hotline: <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a></p>

          <a name="#cg"></a>
          <h4 class="sui-header">Gibt es Portsperren?</h4>
          <p>Nein, nach dem Login sind alle Ports geöffnet. Es gibt keinerlei Beschränkungen.</p>

          <a name="#ch"></a>
          <h4 class="sui-header">Wie kann ich Zugangsdaten online erwerben?</h4>
          <p>Zugangsdaten können Sie direkt in unserem Onlineshop erwerben. <a href="https://shop.lan1.de">[Zum Onlineshop]</a></p>

          <a name="#ci"></a>
          <h4 class="sui-header">Wie bekomme ich eine Quittung/Rechnung?</h4>
          <p>Wenden Sie sich bitte per E-Mail an <a href="mailto:info@lan1.de">info@lan1.de</a> oder direkt an unsere Hotline unter <a href="tel:+4940317666666">+49 (0)40 317 66 66 66</a>.</p>


        </fieldset>

      </sui-modal-description>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button positive @click="toggle">Close</sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
  export default {
    name: 'Help',
    props: ['open'],
    methods: {
      toggle(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('closeModal')
      },
    },
  };</script>
